import { createApi } from "@reduxjs/toolkit/query/react";
import { ApiEndpoints, baseQueryWithAuth } from "../../core";
import {
  AddScreensRequest,
  AddScreensResponse,
  PlansResponse,
} from "../../types";
import { toast } from "../../core/toast";

export const subscriptionScreenApi = createApi({
  reducerPath: "subscriptionScreenApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Subscription", "Screen","SubscriptionScreens"],
  endpoints: (builder) => ({
    addScreens: builder.mutation<AddScreensResponse, AddScreensRequest>({
      query: (body) => ({
        url: ApiEndpoints.addSubscriptionScreen,
        method: "POST",
        body,
      }),
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          toast.success(data?.message || "Success");
        } catch (err: any) {
          toast.error(err?.error?.data?.message || "Error");
        }
      },
      invalidatesTags: ["Subscription", "Screen"],
    }),
  
    getSubscriptionsSummary: builder.query<any, void>({
      query: () => ({
        url: ApiEndpoints.getSubscription,
        method: "GET",
      }),
      providesTags: (result) =>
        result && Array.isArray(result.results)
          ? [
              ...result.results.map((r: any) => ({
                type: "SubscriptionScreens" as const,
                id: r._id,
              })),
              { type: "SubscriptionScreens" as const, id: "LIST" },
            ]
          : [{ type: "SubscriptionScreens" as const, id: "LIST" }],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // toast.success(data?.message || "Success");
        } catch (err: any) {
          // toast.error(err?.error?.data?.message || "Error");
        }
      },
    }),
    getScreens: builder.query<any, void>({
      query: () => ({
        url: ApiEndpoints.getSubscriberScreens,
        method: "GET",
      }),
      providesTags: (result) =>
        result && Array.isArray(result.results)
          ? [
              ...result.results.map((r: any) => ({
                type: "SubscriptionScreens" as const,
                id: r._id,
              })),
              { type: "SubscriptionScreens" as const, id: "LIST" },
            ]
          : [{ type: "SubscriptionScreens" as const, id: "LIST" }],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // toast.success(data?.message || "Success");
        } catch (err: any) {
          // toast.error(err?.error?.data?.message || "Error");
        }
      },
    }),
    downgradeScreen: builder.mutation<
      any,
      { screenId: string ; planId: string  }
    >({
      query: ({ screenId, planId }) => ({
        url: `${ApiEndpoints.downgradeSubscriberScreen}/${screenId}/${planId}`,
        method: "PATCH",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          toast.success(data?.message || "Screen downgraded successfully");
          dispatch(
            subscriptionScreenApi.util.invalidateTags(["SubscriptionScreens"])
          );
        } catch (err: any) {
          toast.error(err?.error?.data?.message || "Error downgrading screen");
        }
      },
      invalidatesTags: ["Subscription", "Screen"],
    }),
    upgradeScreen: builder.mutation<any, { screenId: string ; planId: string  }>({
      query: ({ screenId, planId }) => ({
        url: `${ApiEndpoints.upgradeSubscriberScreen}/${screenId}/${planId}`,
        method: "PATCH",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          toast.success(data?.message || "Screen upgraded successfully");
          dispatch(
            subscriptionScreenApi.util.invalidateTags(["SubscriptionScreens"])
          );
        } catch (err: any) {
          toast.error(err?.error?.data?.message || "Error upgrading screen");
        }
      },
      invalidatesTags: ["Subscription", "Screen"],
    }),
    cancelScreen: builder.mutation<any, { screenId: string }>({
      query: ({ screenId }) => ({
        url: `${ApiEndpoints.cancelSubscriberScreen}/${screenId}`,
        method: "PATCH",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          toast.success(data?.message || "Screen deleted successfully");
          dispatch(
            subscriptionScreenApi.util.invalidateTags(["SubscriptionScreens"])
          );
        } catch (err: any) {
          toast.error(err?.error?.data?.message || "Error deleting screen");
        }
      },
      invalidatesTags: ["Subscription", "Screen"],
    }),
  }),
});

export const {
  useAddScreensMutation,
  useGetSubscriptionsSummaryQuery,
  useGetScreensQuery,
  useDowngradeScreenMutation,
  useUpgradeScreenMutation,
  useCancelScreenMutation,
} = subscriptionScreenApi;
